import { render, staticRenderFns } from "./Guarantees.vue?vue&type=template&id=841252c8&scoped=true"
import script from "./Guarantees.vue?vue&type=script&lang=js"
export * from "./Guarantees.vue?vue&type=script&lang=js"
import style0 from "./Guarantees.vue?vue&type=style&index=0&id=841252c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841252c8",
  null
  
)

export default component.exports